module.exports = __webpack_public_path__ + "img/s3Model1.fcae3f67.webp";